import React = require("react");
import {Types} from "../../types/Types";
import {Granularity, GranularityType, PredefinedPeriod, Toolbar} from "./Toolbar";

/**
 * This object describes the context of toolbar and it is used to expose
 * to all toolbar's children components the state and all method to change it.
 * Refer to React Context Api to see how context is used.
 */
export interface ToolbarContextInterface {
    toolSelectedKey: any;
    timelineExtent: Types.Period;
    timelineSelectedPeriod: Types.Period;
    timelineMaxExtent: Types.Period;
    handleToolSelectedChange: (newValue: any) => void;
    handleTimelineSelectedPeriodChange: (newPeriod: Types.Period) => void;
    handleTimelineExtentChange: (newExtent: Date[]) => void;
    handleTimelineExtentStartChange: (newExtentStart: Date) => void;
    handleTimelineExtentEndChange: (newExtentEnd: Date) => void;
    handleMoveExtent: (direction: string) => void;
    handleBrushEnd: (newPeriod: Types.Period) => void;
    handleGranularitySelectedChange: (newGranularitySelected: GranularityType,
                                      newExtent: Types.Period,
                                      newSelectedPeriod: Types.Period,
                                      newMaxExtent) => void;
    granularitySelected: number;
    granularities: Granularity[];
    canMoveExtentBack: boolean;
    canMoveExtentForward: boolean;
    getGranularitySelected: () => Granularity;
    getPrettyExtentDuration: () => string;
}

export const toolbarContext = React.createContext<ToolbarContextInterface | null>(null);

export const ToolbarContextProvider = toolbarContext.Provider;
export const ToolbarContextConsumer = toolbarContext.Consumer;
